<div class="loader-message-wrapper">
    <epd-spinner size="medium" [isVisible]="true" [fullscreen]="false"></epd-spinner>
    <p class="body-md-16-regular loader-message-text">{{ loaderMessage }}</p>
</div>
